import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { SidenavService } from '../../../services/sidenav-service.service';

@Component({
  selector: 'app-landing-toolbar',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule
  ],
  templateUrl: './landing-toolbar.component.html',
  styleUrl: './landing-toolbar.component.scss'
})
export class LandingToolbarComponent {

  constructor(
    private sidenavService: SidenavService
  ) {

  }

  toggleSidenav() {
    this.sidenavService.open();
  }

}
